module.exports = __webpack_public_path__ + "img/indus-pic-8.c1126ac4.png";